<template>
<div class="tags">
  <span v-if="unresolvedFindings.length > 0" class="tag is-danger">
    {{ unresolvedFindings.length }} finding<span v-if="unresolvedFindings.length !== 1">s</span>
  </span>
  <icon v-if="unresolvedFindings.length === 0 && attribute.value !== null" icon="check-circle" type="far" class="has-text-success fa-2x"/>
  <icon v-if="attribute.value === null && unresolvedFindings.length === 0" icon="circle" type="far" class="has-text-grey fa-2x"/>
</div>  
</template>
<script>
import { uniqBy } from 'lodash'

export default {
  
  props: {
    attribute: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    unresolvedBVulnerabilities() {
      return this.attribute.unresolved_findings.filter(vulnerability => vulnerability.pivot.is_vulnerable)
    },
    unresolvedFindings() {
      return uniqBy(this.attribute.unresolved_findings, 'vulnerable_id')
    },
  }

}
</script>